var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#236BFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 13.41L12.7102 9.17C12.6172 9.07628 12.5066 9.00188 12.3848 8.95111C12.2629 8.90035 12.1322 8.87421 12.0002 8.87421C11.8682 8.87421 11.7375 8.90035 11.6156 8.95111C11.4938 9.00188 11.3832 9.07628 11.2902 9.17L7.05019 13.41C6.95646 13.503 6.88207 13.6136 6.8313 13.7354C6.78053 13.8573 6.75439 13.988 6.75439 14.12C6.75439 14.252 6.78053 14.3827 6.8313 14.5046C6.88207 14.6264 6.95646 14.737 7.05019 14.83C7.23756 15.0163 7.49101 15.1208 7.75519 15.1208C8.01938 15.1208 8.27283 15.0163 8.46019 14.83L12.0002 11.29L15.5402 14.83C15.7265 15.0147 15.9779 15.1189 16.2402 15.12C16.3718 15.1208 16.5023 15.0955 16.6241 15.0458C16.7459 14.996 16.8568 14.9227 16.9502 14.83C17.0473 14.7404 17.1256 14.6324 17.1807 14.5123C17.2358 14.3923 17.2666 14.2625 17.2713 14.1304C17.2759 13.9984 17.2543 13.8667 17.2078 13.7431C17.1613 13.6194 17.0907 13.5062 17.0002 13.41Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUChevronUp);
export default __webpack_public_path__ + "static/media/u_chevron-up.93823e53.svg";
export { ForwardRef as ReactComponent };